/* In most cases Faroe and Greenland should use the same features as Denmark, even though we are not supporting them officially */
export const shouldUseDKFeatures = (country?: string): boolean =>
  country === 'DK' || country === 'FO' || country === 'GL'
